import { Platform } from 'utils/platform';

import { TvResetPinMessageModal } from './TvResetPinMessageModal';
import { WebResetPinMessageModal } from './WebResetPinMessageModal';

export type ResetPinMessageModalProps = {
  isOpen: boolean;
  type?: 'success' | 'error';
  title?: string;
  message?: string;
  onClose: () => void;
};

export const ResetPinMessageModal = (props: ResetPinMessageModalProps) => {
  if (Platform.isTV) {
    return <TvResetPinMessageModal {...props} />;
  }

  return <WebResetPinMessageModal {...props} />;
};
